import React, { useState } from 'react'
import { Play } from 'lucide-react'

/* Façade légère pour les vidéos YouTube (chargement à la demande) */
const YouTubeVideoWithThumbnail = ({ videoId, title }) => {
  const [isPlaying, setIsPlaying] = useState(false)

  const thumbnailUrl = `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`
  const fallbackThumb = `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`
  const embedUrl = `https://www.youtube.com/embed/${videoId}?autoplay=1`

  return (
    <div className="w-full h-full">
      {!isPlaying ? (
        <button
          type="button"
          className="group relative w-full h-full cursor-pointer bg-transparent border-none p-0 overflow-hidden"
          onClick={() => setIsPlaying(true)}
          aria-label={`Lire la vidéo : ${title}`}
        >
          <img
            src={thumbnailUrl}
            onError={(e) => {
              if (e.currentTarget.src !== fallbackThumb) e.currentTarget.src = fallbackThumb
            }}
            alt={`Miniature de la vidéo : ${title}`}
            className="object-contain w-full h-full transition-transform duration-700 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-[#0a0218]/70 via-transparent to-transparent transition-opacity group-hover:opacity-80" />
          <span className="absolute inset-0 grid place-items-center" aria-hidden="true">
            <span className="grid place-items-center h-16 w-16 rounded-full bg-grad-violet shadow-glow transition-transform duration-500 group-hover:scale-110">
              <Play size={24} className="text-white translate-x-0.5" fill="currentColor" />
            </span>
          </span>
        </button>
      ) : (
        <iframe
          className="w-full h-full"
          src={embedUrl}
          style={{ border: 'none' }}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          title={title}
          tabIndex={0}
        />
      )}
    </div>
  )
}

export default YouTubeVideoWithThumbnail
